<div class="wrap-x wrap-l">
    <div class="flex flex-justify-between wrap p-l-0 p-r-0-s p-r-0-m p-r-0-l">
        <div>
            <p class="p-b p-t-6 p-l-4-s p-l-4-m"
               sizeClass="XL:h3, SM: h4"
               *iCms="'title' of content"></p>
        </div>

        <div class="flex m-t-6 p-r-10-l p-r-4-s p-b-5 p-r-4-m z-1 swiper-nav-buttons">
            <button class="b-radius-max m-r-2 flex flex-justify-center flex-middle swiper-nav-button"
                    [ngClass]="'item-prev-' + uid"
                    type="button"
                    [attr.aria-label]="'Previous slide' | translate">
                <i class="icon-chevron-left col-6 fs-3 inline-flex"
                   aria-hidden="true">
                </i>
            </button>
            <button class="b-radius-max flex flex-justify-center flex-middle swiper-nav-button"
                    [ngClass]="'item-next-' + uid"
                    type="button"
                    [attr.aria-label]="'Next slide' | translate">
                <i class="icon-chevron-right col-6 fs-3 inline-flex"
                   aria-hidden="true">
                </i>
            </button>
        </div>
    </div>
    <carousel class="w-12 p-b-7 p-l p-l-0-l p-l-0-x ugc-carousel"
              [slidesPerView]="slidesPerView"
              [spaceBetween]="20"
              [loop]="false"
              [navigation]="{
                          nextEl: '.item-next-' + uid,
                          prevEl: '.item-prev-' + uid
                      }">
        @for (model of images; track trackByImageId($index, model)) {
        <ng-template swiperSlide>
            <ugc-image-item [model]="model"
                            [shopTheLook]="true"
                            [shopTheLookUnder]="client.sizeId < 2"></ugc-image-item>
        </ng-template>
        }
    </carousel>
</div>
